import { render, staticRenderFns } from "./QuotaBalance.vue?vue&type=template&id=5da69371&"
import script from "./QuotaBalance.vue?vue&type=script&lang=js&"
export * from "./QuotaBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports